import type { JSX } from 'react'
import type { IButtonProps } from 'atoms/Button'
import type { IButtonGroupProps } from '../ButtonGroup'

import { SecondaryOpacityFavoriteToggleButton } from 'atoms/ActionButton/Templates'
import { PlayPrimaryButton } from 'atoms/Button/Templates'
import { ButtonGroup } from '../ButtonGroup'

export interface IButtonGroupTemplate2Props extends Omit<
  IButtonGroupProps,
  'children'
> {
  list: [IButtonProps['title']]
}

export const ButtonGroupTemplate2 = ({
  list,
  ...rest
}: IButtonGroupTemplate2Props): JSX.Element => (
  <ButtonGroup {...rest}>
    <PlayPrimaryButton title={list?.[0] || ''} />
    <SecondaryOpacityFavoriteToggleButton />
  </ButtonGroup>
)
